import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ParallaxScaler } from '../js/parallax-scaler'
import { ParallaxScroll } from '../js/parallax-scroll'
import { DotLottie } from '@lottiefiles/dotlottie-web'

require('normalize.css/normalize.css')
require('../css/main.scss')
require('./page.scss')

const setParallaxScaler = () => {
  // eslint-disable-next-line no-new
  new ParallaxScaler('.century__img-parallax', {
    scale: 1.3,
    speed: 0.8,
    ease: 'none',
    scrub: 1,
    onUpdate: null
  })
}

const setParallaxScroll = () => {
  // eslint-disable-next-line no-new
  new ParallaxScroll({
    selector: '[data-parallax]',
    direction: 'up',
    smooth: 0.1
  })
}

window.addEventListener('load', () => {
  gsap.registerPlugin(ScrollTrigger)
  ScrollTrigger.config({ ignoreMobileResize: true })
  ScrollTrigger.normalizeScroll(true)

  setParallaxScaler()
  setParallaxScroll()

  const isMobile = window.matchMedia('(max-width: 520px)').matches
  const isTablet = window.matchMedia('(min-width: 520px) and (max-width: 1024px)').matches

  const heroVideo = document.getElementById('hero-video')
  const heroLottie = document.getElementById('hero-lottie')
  const centuryVideo = document.querySelector('#century-video')
  const exploreMedia = document.querySelector('.explore__media')
  const exploreMediaPin = document.querySelector('.explore__media-pin')
  const exploreMediaFrame = document.querySelector('.explore__media-frame')
  const isMobileVideo = window.matchMedia('(max-width: 768px)').matches

  if (isMobileVideo) {
    if (heroVideo) heroVideo.style.display = 'none'
    if (heroLottie) {
      // eslint-disable-next-line no-new
      new DotLottie({
        canvas: heroLottie,
        src: '/assets/anniversity/lottie/Mobile_Hero_Animation_1.lottie',
        loop: false,
        autoplay: true
      })
    }
  } else {
    if (heroLottie) heroLottie.style.display = 'none'
    if (heroVideo) heroVideo.loop = true
  }

  gsap.set('.century__text h1, .century__text p', {
    opacity: 0
  })

  gsap.to('.century', {
    scrollTrigger: {
      trigger: '.century',
      pin: '.century__text',
      start: isTablet ? '100px center' : isMobile ? '100px 43%' : '20% center',
      end: isTablet ? '80% 70%' : isMobile ? '87% 80%' : '75% 70%',
      scrub: 1,
      onEnter: () => {
        gsap.to('.century__text h1', {
          opacity: 1,
          duration: 0.7
        })
        gsap.to('.century__text p', {
          opacity: 1,
          duration: 0.7,
          delay: 0.5
        })
      },
      onEnterBack: () => {
        gsap.to('.century__text h1', {
          opacity: 1,
          duration: 0.7
        })
        gsap.to('.century__text p', {
          opacity: 1,
          duration: 0.7,
          delay: 0.5
        })
      },
      onLeaveBack: () => {
        gsap.to('.century__text h1', {
          opacity: 0,
          duration: 0.7,
          ease: 'power2.inOut'
        })
        gsap.to('.century__text p', {
          opacity: 0,
          duration: 0.7,
          ease: 'power2.inOut'
        })
      }
    }
  })

  ScrollTrigger.create({
    trigger: '.history__img',
    start: 'top center',
    end: 'bottom center',
    onEnter: () => {
      gsap.to('.century__text h1, .century__text p', {
        opacity: 0,
        duration: 0.7,
        ease: 'power2.inOut'
      })
    },
    onLeaveBack: () => {
      gsap.to('.century__text h1, .century__text p', {
        opacity: 1,
        duration: 0.7,
        ease: 'power2.inOut'
      })
    }
  })

  if (exploreMedia && exploreMediaPin && exploreMediaFrame) {
    const isMobileFrame = () => window.matchMedia('(max-width: 767px)').matches

    const setInitialFrame = () => {
      gsap.set(exploreMediaFrame, {
        scale: isMobileFrame() ? 0.8 : 0.5
      })
    }

    setInitialFrame()

    gsap.to(exploreMediaFrame, {
      scrollTrigger: {
        trigger: exploreMedia,
        start: 'top 80%',
        end: 'top top',
        scrub: true,
        invalidateOnRefresh: true,
        onRefreshInit: setInitialFrame
      },
      scale: 1,
      ease: 'none'
    })

    // 2. Pinning and content interaction animation
    const mediaTl = gsap.timeline({
      scrollTrigger: {
        trigger: exploreMedia,
        start: 'top top',
        end: '+=80%',
        scrub: true,
        pin: true,
        pinSpacing: true,
        invalidateOnRefresh: true
      }
    })

    const explorePlay = exploreMedia.querySelector('.explore__play')
    const videoControls = exploreMedia.querySelector('.video-controls')

    if (explorePlay) {
      mediaTl.to(explorePlay, {
        ease: 'power2.inOut'
      }, 0)
    }

    if (videoControls) {
      mediaTl.to(videoControls, {
        y: 20,
        ease: 'power2.inOut'
      }, 0)
    }
  }

  const industryTl = gsap.timeline({
    scrollTrigger: {
      trigger: '.js-industry',
      start: 'top 80%'
    }
  })

  industryTl
    .to('.js-industry-eyebrow', { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' })
    .to('.js-industry-title', { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }, '-=0.6')
    .to('.js-industry-description', { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }, '-=0.6')
    .to('.js-industry-actions', { opacity: 1, y: 0, duration: 0.8, ease: 'back.out(1.7)' }, '-=0.4')

  if (!window.matchMedia('(max-width: 991px)').matches) {
    gsap.fromTo('.industry__image',
      { x: 200 },
      {
        x: -100,
        ease: 'none',
        scrollTrigger: {
          trigger: '.js-industry',
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1
        }
      }
    )
  }

  // Video Controls Logic
  const explorePlayOverlay = document.querySelector('.explore__play')
  const videoControls = document.getElementById('video-controls')
  const playPauseBtn = document.getElementById('video-play-pause')
  const playIcon = document.getElementById('play-icon')
  const pauseIcon = document.getElementById('pause-icon')
  const volumeBtn = document.getElementById('video-volume')
  const volumeOnIcon = document.getElementById('volume-on-icon')
  const volumeOffIcon = document.getElementById('volume-off-icon')
  const seekRange = document.getElementById('video-seek')
  const progressBar = document.getElementById('video-progress-bar')
  const currentTimeDisplay = document.getElementById('current-time')
  const totalTimeDisplay = document.getElementById('total-time')
  const fullscreenBtn = document.getElementById('video-fullscreen')

  function formatTime (seconds) {
    if (isNaN(seconds)) return '0:00'
    const min = Math.floor(seconds / 60)
    const sec = Math.floor(seconds % 60)
    return `${min}:${sec < 10 ? '0' + sec : sec}`
  }

  const updatePlayPauseUI = (isPlaying) => {
    if (isPlaying) {
      if (playIcon) playIcon.style.display = 'none'
      if (pauseIcon) pauseIcon.style.display = 'block'
    } else {
      if (playIcon) playIcon.style.display = 'block'
      if (pauseIcon) pauseIcon.style.display = 'none'
    }
  }

  if (explorePlayOverlay && centuryVideo) {
    explorePlayOverlay.addEventListener('click', (e) => {
      e.preventDefault()
      explorePlayOverlay.style.display = 'none'
      if (videoControls) videoControls.style.display = 'flex'
      centuryVideo.muted = false
      centuryVideo.currentTime = 0
      centuryVideo.play()
      updatePlayPauseUI(true)
    })
  }

  if (playPauseBtn && centuryVideo) {
    playPauseBtn.addEventListener('click', () => {
      if (centuryVideo.paused) {
        centuryVideo.play()
        updatePlayPauseUI(true)
      } else {
        centuryVideo.pause()
        updatePlayPauseUI(false)
      }
    })
  }

  if (volumeBtn && centuryVideo) {
    volumeBtn.addEventListener('click', () => {
      centuryVideo.muted = !centuryVideo.muted
      if (centuryVideo.muted) {
        if (volumeOnIcon) volumeOnIcon.style.display = 'none'
        if (volumeOffIcon) volumeOffIcon.style.display = 'block'
      } else {
        if (volumeOnIcon) volumeOnIcon.style.display = 'block'
        if (volumeOffIcon) volumeOffIcon.style.display = 'none'
      }
    })
  }

  if (centuryVideo) {
    centuryVideo.addEventListener('timeupdate', () => {
      const duration = centuryVideo.duration || 0
      const value = duration > 0 ? (centuryVideo.currentTime / duration) * 100 : 0
      if (seekRange) seekRange.value = value
      if (progressBar) progressBar.style.width = value + '%'
      if (currentTimeDisplay) currentTimeDisplay.textContent = formatTime(centuryVideo.currentTime)
    })

    centuryVideo.addEventListener('loadedmetadata', () => {
      if (totalTimeDisplay) totalTimeDisplay.textContent = formatTime(centuryVideo.duration)
    })
  }

  if (seekRange && centuryVideo) {
    seekRange.addEventListener('input', () => {
      const time = (seekRange.value / 100) * centuryVideo.duration
      centuryVideo.currentTime = time
    })
  }

  if (fullscreenBtn && centuryVideo) {
    fullscreenBtn.addEventListener('click', () => {
      if (centuryVideo.requestFullscreen) {
        centuryVideo.requestFullscreen()
      } else if (centuryVideo.webkitRequestFullscreen) {
        centuryVideo.webkitRequestFullscreen()
      } else if (centuryVideo.msRequestFullscreen) {
        centuryVideo.msRequestFullscreen()
      }
    })
  }

  const settingsBtn = document.getElementById('video-settings')
  const settingsPanel = document.getElementById('video-settings-panel')

  if (settingsBtn && settingsPanel && centuryVideo) {
    settingsBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      settingsPanel.classList.toggle('is-open')
    })

    settingsPanel.querySelectorAll('.video-controls__speed-opt').forEach((btn) => {
      btn.addEventListener('click', () => {
        const speed = parseFloat(btn.dataset.speed)
        centuryVideo.playbackRate = speed
        settingsPanel.querySelectorAll('.video-controls__speed-opt').forEach((b) => {
          b.classList.remove('video-controls__speed-opt--active')
        })
        btn.classList.add('video-controls__speed-opt--active')
        settingsPanel.classList.remove('is-open')
      })
    })

    document.addEventListener('click', () => {
      settingsPanel.classList.remove('is-open')
    })
  }
})
